
import { Component, Prop, Vue } from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'catalog-search-view',
  components: ServiceContainer().getComponents(),
})
export default class extends Vue {
  @Prop() readonly searchedQuery: string;
  @Prop() readonly catalogData: object;
  @Prop() readonly dataSource: string;
  @Prop() readonly imageBaseUrl: string;

  @Prop({ default: 6 }) private chunkSize: number;
  @Prop({ default: () => [] }) private wishlistItems: Array<object>;

  private created(): void {
    this.$store.commit(`${this.dataSource}/SET_SEARCHED_QUERY`, this.searchedQuery);
    this.$store.commit(`${this.dataSource}/SET_API_RESPONSE`, this.catalogData);

    window.onpopstate = ({ state }) => {
      this.$store.commit(`${this.dataSource}/SET_SEARCHED_QUERY`, null === state ? this.searchedQuery : state['searchedQuery']);
      this.$store.commit(`${this.dataSource}/SET_API_RESPONSE`, null === state ? this.catalogData : state['catalogData']);
    };
  }

  private mounted(): void {
    window.addEventListener('load', () => {
      if (document.getElementsByClassName('catalog__category-placeholder').length) {
        (document.getElementsByClassName('catalog__category-placeholder')[0] as HTMLElement).style.display = 'none';
      }
      if (document.getElementsByClassName('catalog__category-filter-placeholder').length) {
        (document.getElementsByClassName('catalog__category-filter-placeholder')[0] as HTMLElement).style.display = 'none';
      }
    });
  }
}
